export const state = {
  customizedTables: { tables: [] },
};
